import { getCurrentCompanies } from '../api/statistics';
import useData from './useData';

const useCompanies = () => useData(async () => (await getCurrentCompanies()).data.resultList, []);

export default useCompanies;
